export const PaymentStatusEnum = {
  APPLIED: 'Applied',
  REVERSED: 'Reversed',
  PENDING: 'Pending',
  NSF: 'NSF',
};

export const PaymentStatusLabel = {
  [PaymentStatusEnum.APPLIED]: 'Applied',
  [PaymentStatusEnum.REVERSED]: 'Reversed',
  [PaymentStatusEnum.PENDING]: 'Pending',
  [PaymentStatusEnum.NSF]: 'NSF',
};

const PaymentMethodEnum = {
  CHECK: 'Check',
  ACH: 'ACH',
  WIRE: 'Wire',
  OTHER: 'Other',
};

export const PaymentMethodLabel = {
  [PaymentMethodEnum.CHECK]: 'Check',
  [PaymentMethodEnum.ACH]: 'ACH',
  [PaymentMethodEnum.WIRE]: 'Wire',
  [PaymentMethodEnum.OTHER]: 'Other',
};

export const ScheduleStatusEnum = {
  UPCOMING: 'Upcoming',
  PAID: 'Paid',
  PAST_DUE: 'PastDue',
  PARTIAL: 'Partial',
};

export const ScheduleStatusLabel = {
  [ScheduleStatusEnum.UPCOMING]: 'Upcoming',
  [ScheduleStatusEnum.PAID]: 'Paid',
  [ScheduleStatusEnum.PAST_DUE]: 'Past Due',
  [ScheduleStatusEnum.PARTIAL]: 'Partial',
};

const DisbursementTypeEnum = {
  PROPERTY_TAX: 'PropertyTax',
  HOMEOWNERS_INSURANCE: 'HomeownersInsurance',
  MORTGAGE_INSURANCE: 'MortgageInsurance',
  FLOOD_INSURANCE: 'FloodInsurance',
  HOA: 'HOA',
  OTHER: 'Other',
};

export const DisbursementTypeLabel = {
  [DisbursementTypeEnum.PROPERTY_TAX]: 'Property Tax',
  [DisbursementTypeEnum.HOMEOWNERS_INSURANCE]: 'Homeowners Insurance',
  [DisbursementTypeEnum.MORTGAGE_INSURANCE]: 'Mortgage Insurance',
  [DisbursementTypeEnum.FLOOD_INSURANCE]: 'Flood Insurance',
  [DisbursementTypeEnum.HOA]: 'HOA',
  [DisbursementTypeEnum.OTHER]: 'Other',
};

export const DISBURSEMENT_TYPE_OPTIONS = Object.entries(DisbursementTypeLabel).map(
  ([value, name]) => ({
    value,
    name,
  }),
);

export const InteractionTypeEnum = {
  INBOUND_CALL: 'InboundCall',
  OUTBOUND_CALL: 'OutboundCall',
  EMAIL: 'Email',
  LETTER: 'Letter',
  IN_PERSON: 'InPerson',
  OTHER: 'Other',
};

export const InteractionTypeLabel = {
  [InteractionTypeEnum.INBOUND_CALL]: 'Inbound Call',
  [InteractionTypeEnum.OUTBOUND_CALL]: 'Outbound Call',
  [InteractionTypeEnum.EMAIL]: 'Email',
  [InteractionTypeEnum.LETTER]: 'Letter',
  [InteractionTypeEnum.IN_PERSON]: 'In Person',
  [InteractionTypeEnum.OTHER]: 'Other',
};

export const INTERACTION_TYPE_OPTIONS = Object.entries(InteractionTypeLabel).map(
  ([value, name]) => ({
    value,
    name,
  }),
);

export const FollowUpStatusLabel = {
  true: 'Completed',
  false: 'Pending',
};

export const PAYMENT_METHOD_OPTIONS = Object.entries(PaymentMethodLabel).map(([value, name]) => ({
  value,
  name,
}));

export const PAYMENT_STATUS_OPTIONS = [
  { value: PaymentStatusEnum.APPLIED, name: PaymentStatusLabel[PaymentStatusEnum.APPLIED] },
  { value: PaymentStatusEnum.PENDING, name: PaymentStatusLabel[PaymentStatusEnum.PENDING] },
  { value: PaymentStatusEnum.NSF, name: PaymentStatusLabel[PaymentStatusEnum.NSF] },
];

export const DrawRequestStatusEnum = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  DENIED: 'Denied',
  CANCELLED: 'Cancelled',
};

export const DrawRequestStatusLabel = {
  [DrawRequestStatusEnum.PENDING]: 'Pending',
  [DrawRequestStatusEnum.APPROVED]: 'Approved',
  [DrawRequestStatusEnum.DENIED]: 'Denied',
  [DrawRequestStatusEnum.CANCELLED]: 'Cancelled',
};

export const DRAW_REQUEST_STATUS_OPTIONS = Object.entries(DrawRequestStatusLabel).map(
  ([value, name]) => ({
    value,
    name,
  }),
);

const PaymentPhaseEnum = {
  DRAW: 'Draw',
  REPAYMENT: 'Repayment',
};

export const PaymentPhaseLabel = {
  [PaymentPhaseEnum.DRAW]: 'Draw Period',
  [PaymentPhaseEnum.REPAYMENT]: 'Repayment Period',
};
